import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bca0a31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-footer d-flex align-items-center" }
const _hoisted_2 = { style: {"margin-right":"auto"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "footer-copy" }, "TenantHub Pty Ltd © 2023", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" Tenant Reference Report generated by "),
  /*#__PURE__*/_createElementVNode("strong", null, "Tenant Hub")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainLogo = _resolveComponent("MainLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MainLogo, { class: "footer-logo-image" }),
      _hoisted_3
    ]),
    _hoisted_4
  ]))
}